import MeetingMessageButtonEntrySource from '../store/schema/MeetingMessageButtonEntrySource';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics-actions';
import { assertNever } from 'owa-assert';
import loc from 'owa-localize';
import { removeTooltip } from 'owa-locstrings/lib/strings/removetooltip.locstring.json';
import { rsvpLabel } from 'owa-locstrings/lib/strings/rsvplabel.locstring.json';
import {
    isMeetingCancellation,
    isMeetingRequest,
    lazyRemoveCancelledMeetingFromCalendar,
} from 'owa-meeting-message';
import { lazyShowRSVPPeek, RSVPPeek } from 'owa-rsvp-peek';
import shouldShowRSVPPeek from 'owa-rsvp-peek/lib/selectors/shouldShowRSVPPeek';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';

const styles = require('./MeetingMessageButton.scss');

export interface MeetingMessageButtonProps {
    item: Partial<MeetingRequestMessageType> | MeetingCancellationMessageType;
    entrySource: MeetingMessageButtonEntrySource;
}

@observer
export default class MeetingMessageButton extends React.Component<MeetingMessageButtonProps, {}> {
    private rsvpButtonRef;

    componentDidMount() {
        const { item, entrySource } = this.props;
        let buttonType;

        if (isMeetingRequest(item.ItemClass)) {
            buttonType = 'RSVP';
        } else if (isMeetingCancellation(item.ItemClass)) {
            buttonType = 'Remove';
        } else {
            assertNever(item.ItemClass as never);
        }

        const readingPanePosition = getUserConfiguration().UserOptions
            .GlobalReadingPanePositionReact;
        logUsage('MeetingMessageButtonShown', { buttonType, entrySource, readingPanePosition });
    }

    render() {
        const { item, entrySource } = this.props;

        let actionButton = null;

        if (isMeetingRequest(item.ItemClass)) {
            actionButton = (
                <>
                    <div
                        tabIndex={0}
                        ref={this.rsvpButtonRefCallback}
                        title={loc(rsvpLabel)}
                        className={styles.container}
                        onClick={this.onRSVP}
                        onDoubleClick={this.onDoubleClick}
                        onContextMenu={this.onContextMenu}>
                        <div className={styles.textContent}>
                            <span>{loc(rsvpLabel)}</span>
                        </div>
                    </div>
                    {shouldShowRSVPPeek(item.ItemId.Id, entrySource) ? (
                        <RSVPPeek item={item} calloutTarget={this.rsvpButtonRef} />
                    ) : null}
                </>
            );
        } else if (isMeetingCancellation(item.ItemClass)) {
            actionButton = (
                <div
                    tabIndex={0}
                    title={loc(removeTooltip)}
                    className={styles.container}
                    onClick={this.onRemove}
                    onDoubleClick={this.onDoubleClick}>
                    <span className={styles.textContent}>{loc(removeTooltip)}</span>
                </div>
            );
        }

        return actionButton;
    }

    private rsvpButtonRefCallback = (ref: HTMLDivElement) => {
        this.rsvpButtonRef = ref;
    };

    private onRemove = (ev?: any) => {
        ev.stopPropagation();
        lazyRemoveCancelledMeetingFromCalendar.importAndExecute(this.props.item, 'RSVPPeek');
    };

    private onRSVP = (evt?: any) => {
        evt.stopPropagation();
        lazyShowRSVPPeek.importAndExecute(this.props.item, this.props.entrySource);
    };

    private onContextMenu(ev: React.MouseEvent<HTMLDivElement>) {
        ev.preventDefault();
        ev.stopPropagation();
    }

    private onDoubleClick(ev: React.MouseEvent<HTMLDivElement>) {
        ev.preventDefault();
        ev.stopPropagation();
    }
}
